import {Component, Input} from '@angular/core';
import {DividerModule} from 'primeng/divider';
import {TranslateModule} from '@ngx-translate/core';
import {AbstractSigaleComponent} from '../abstract-sigale.component';
import {CommonModule} from '@angular/common';

@Component({
	selector: 'sigale-divider',
	templateUrl: './divider.component.html',
	styleUrls: ['./divider.component.scss'],
	imports: [CommonModule, TranslateModule, DividerModule],
	standalone: true
})
export class DividerComponent extends AbstractSigaleComponent {

	@Input() titre: string;

	constructor() {
		super();
	}

	ngOnInit() {
		super.ngOnInit();
	}
}
